import { useMemo } from 'react'

import { NotificationVerb } from 'src/shared/schemas/notifications'

type EnterpriseInvitationSubtitleProps = {
  enterpriseName: string
  notificationVerb: NotificationVerb
}

const EnterpriseInvitationSubtitle = ({ enterpriseName, notificationVerb }: EnterpriseInvitationSubtitleProps) => {
  const text = useMemo(() => {
    if (!notificationVerb) {
      return `Click here to view your invitation to ${enterpriseName}`
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_SENT) {
      return `Click here to accept your invitation to ${enterpriseName}`
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_ACCEPTED) {
      return `Click here to view your invitation to ${enterpriseName}`
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_DECLINED) {
      return `Click here to view your invitation to ${enterpriseName}`
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_CANCELED) {
      return `Click here to view your invitation to ${enterpriseName}`
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_EXPIRED) {
      return `Click here to view your invitation to ${enterpriseName}`
    }
    return null
  }, [notificationVerb, enterpriseName])

  return <p className="text-[13px] leading-[18px] text-muted">{text}</p>
}

export default EnterpriseInvitationSubtitle
